import JassEnum from './enum';

/**
 * type unitstate
 */
export default class JassUnitState extends JassEnum {}
